





















































































import { Vue, Component } from "../vue-ext";
import { HousingCompany, Account, User } from "../models";

@Component
export default class ContentView extends Vue {
    private menuActive: boolean = false;
    private user: User | null = null;
    private account: Account | null = null; 
    private housingCompany: HousingCompany | null = null; 
    // private unreadHousingCompanyMessageCount: number = 0;
    // private unreadTotalMessageCount: number = 1;

    private async created() {
        if (!this.root.isAuthenticated()) {
            this.$router.push("/");
        }

        this.user = this.root.getCurrentUser() as User;
        this.account = this.root.getCurrentAccount() as Account;
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;
        
        // await this.root.updateMessages();

        // this.unreadHousingCompanyMessageCount = this.root.unreadMessagesCount; //.getUnreadMessageCount();

        // this.unreadTotalMessageCount = this.root.getAllOwnMessages().filter(m => m.readOn === null).length - this.unreadHousingCompanyMessageCount;
        // this.unreadTotalMessageCount = this.root.allOwnMessages.filter(m => m.readOn === null).length - this.unreadHousingCompanyMessageCount;
    }

    private unreadTotalMessageCount() {
        return this.root.allOwnMessages.filter(m => m.readOn === null).length - this.root.getUnreadMessageCount();
    }

    private toggle(off: boolean = false) {
        if (off) {
            this.menuActive = false;
        } else {
            this.menuActive = !this.menuActive;
        }
    }

    private navigate(event: any) {
        const path = event.currentTarget.getAttribute("url");
        this.$router.push(path);
        this.toggle();
    }

    private swipe(direction: any) {
        switch (direction) {
            case "left":
                this.toggle(true);
                break;
            case "right":
                this.toggle(false);
                break;
        }
    }

    private logOut() {
        this.root.logOut();
    }
}
